import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SupabaseService } from '../../subscription/services/supabase/supabase.service';

export interface CheckHandleResponse {
  available: boolean;
  reason: null | 'taken' | 'profanity' | 'reserved' | 'invalid_format';
}

@Injectable({
  providedIn: 'root'
})
export class HandleValidatorService {
  private supabaseService = inject(SupabaseService);

  /**
   * Check if a handle is available
   * Returns an Observable with availability and reason if unavailable
   */
  checkHandle(handle: string): Observable<CheckHandleResponse> {
    if (!handle || handle.trim().length === 0) {
      return of({ available: true, reason: null });
    }

    return this.supabaseService.invokeFunction<CheckHandleResponse>('check-handle', {
      handle: handle.toLowerCase().trim()
    }).pipe(
      map(response => response ?? { available: false, reason: 'invalid_format' as const }),
      catchError(() => of({ available: false, reason: 'invalid_format' as const }))
    );
  }

  /**
   * Get a user-friendly error message for the validation reason
   */
  getErrorMessage(reason: CheckHandleResponse['reason']): string {
    switch (reason) {
      case 'taken':
        return 'This handle is already taken';
      case 'invalid_format':
        return 'Use 4-24 lowercase letters, numbers, and hyphens';
      case 'profanity':
      case 'reserved':
      default:
        return 'This handle is not available';
    }
  }
}
